export const ADD_POINTS_SUCCESS = 'ADD_POINTS_SUCCESS';
export const POINTS_LOADING = 'POINTS_LOADING';
export const GET_POINTS_SUCCESS = 'GET_POINTS_SUCCESS';
export const UPDATE_POINTS_SUCCESS = 'UPDATE_POINTS_SUCCESS';
